import * as React from 'react';
export const chevronDownSvg = React.forwardRef(function chevronDownSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M.381 3.381a.875.875 0 0 1 1.238 0L6 7.763l4.381-4.382A.875.875 0 1 1 11.62 4.62l-5 5a.875.875 0 0 1-1.238 0l-5-5a.875.875 0 0 1 0-1.238Z',
    }),
  );
});
chevronDownSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var chevronDown = {
  category: 'icon',
  colorable: true,
  name: 'chevronDown',
  svg: chevronDownSvg,
};
